import t from "./index686.js";
import { withInstall as o } from "./index604.js";
const r = o(t);
export {
  r as ElTag,
  r as default
};
